export const events=[{
        "title":"Weddings",
        "subtitle":"Sophistication. Style. Glamour. The ultimate in luxury city weddings.",
        "content":`For A Wedding Experience as Unique as You
We're committed to your dreams coming true, with expert professionals who are
dedicated to getting every last detail right. This experience also means that we're
on top of the latest trends in cuisine and décor. We know vendors with impeccable
histories of bringing wedding ideas and venues to life. And we're always open to
trying something new and fun.`
    
},
{
        "title":"Reception",
        "subtitle":"Your Big Day",
        "content":`Every great love story is special. One of a kind. You’ll never forget how you met, your
first kiss or all of the other reasons you knew this was true love. Whether this is your
wedding day, vow renewal or anniversary, your walk down the aisle should be as
distinctive as your love for one another. You know what you want from your wedding
or commitment ceremony and our planning experts can bring your vision to life. We
can help you find the perfect venue, the ultimate wedding theme, floral
arrangements and everything leading up to your big day and beyond.`
    
},
{
        "title":"Birthdays",
        "subtitle":"Special celebration",
        "content":`Balloons, flowers, personalised cakes or basically all of it? We've got the ultimate
birthday masterplan for that perfect insta-post and the ultimate celebration of the
year`
    
},

];
export const banquet=[{
        "title":"Crown banquet hall",
        
        "content":`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua.`
    
},
{
        "title":"Master Banquet Hall",
        "content":`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua.`
    
},
{
        "title":"Basement Banquet Hall",
        "content":`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua.`
    
},
{
        "title":"Corporate Board Room",
        "content":`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua.`
    
},
{
        "title":"Family Board Room",
        "content":`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua.`
    
},
];
export const OFFER=[{id:"1",service:"Get Free Delivery only Himmatnagar City Area",price:"Total Price: greater than or equal to ₹1,000.00",payment:"Payment Method: Cash,Card at pickup counter"},
{id:"2",service:"Get Free Delivery only Himmatnagar City Area",price:"Total Price: greater than or equal to ₹1,000.00",payment:"Payment Method: Cash,Card at pickup counter"},
{id:"",service:"Get Free Delivery only Himmatnagar City Area",price:"Total Price: greater than or equal to ₹1,000.00",payment:"Payment Method: Cash,Card at pickup counter"}];
export const COUNT_OPTIONS=[{id: "1",name:"1"},{id: "2",name:"2"},{id: "3",name:"3"},{id: "4",name:"4"},{id: "5",name:"5"},{id: "6",name:"6"},{id: "7",name:"7"},{id: "8",name:"8"},{id: "9",name:"9"},{id: "10",name:"10"},{id: "11",name:"11"}]
export const ROOM_OPTIONS=[
{id: "Dulex Room",name:"Dulex Room",desc:"Warm, comfortable and bright rooms . All delux rooms have large king-size beds, with high quality hypoallergenic mattresses."},
{id: "Super Dulex",name:"Super Dulex",desc:"We pay special attention to the decor in order to give each room a unique character and an exceptional atmosphere that guarantees peace and relaxation.."},
{id: "Executive Room",name:"Executive Room",desc:"More spacious rooms beautifully furnished . Executive rooms have a comfortable king-size bed , with high quality hypoallergenic mattresses.."},
{id: "Super Executive",name:"Super Executive",desc:"A room with a view ! The room offers a lovely, discreet and luxurious atmosphere for your stays . With its classNameic setting, guests will be seduced by the room's pleasant decor.."},
{id: "Honeymoon Suite",name:"Honeymoon Suite",desc:"A room with a view ! Specially designed for those who choose to spend their honeymoon,these rooms are deliver premium comfort and facilities."},
{id: "President Suite",name:"President Suite",desc:"You will feel you are at the top of the world. luxurious atmosphere Particularly recommended for a long stay by yourself, as a couple, with the family or with friends."}
];

export const TESTIMONIALS=[{content:`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet,
consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore aliqua. Ut enim ad minim veniam, quis nostrud
exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit`,title:"Lorem ipsum dolor",subtitle:"Cook"},{content:`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet,
consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore aliqua. Ut enim ad minim veniam, quis nostrud
exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit`,title:"Lorem ipsum dolor",subtitle:"Cook"},{content:`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet,
consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore aliqua. Ut enim ad minim veniam, quis nostrud
exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit`,title:"Lorem ipsum dolor",subtitle:"Cook"},{content:`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet,
consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore aliqua. Ut enim ad minim veniam, quis nostrud
exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit`,title:"Lorem ipsum dolor",subtitle:"Cook"}];
export const REVIEWS=[{content:`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
veniam, quis nostrud exercitation ullamco laboris nisi`,gname:"Rose J.",person:"Guest Review"},{content:`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
veniam, quis nostrud exercitation ullamco laboris nisi`,gname:"Jean L.",person:"Guest Review"}]


